var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_18321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 17.196L13.9986 17.3732L13.8293 14.9409",
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 17.196L13.9986 17.3732L13.8293 14.9409",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99803 15.9086C7.15811 15.5295 5.57931 14.8117 4.49953 13.8636C3.41974 12.9154 2.89748 11.7882 3.01144 10.6519C3.12541 9.51554 3.86942 8.43157 5.13136 7.56334C6.39331 6.6951 8.10481 6.08964 10.008 5.83819C11.9111 5.58674 13.9028 5.70293 15.683 6.16923C17.4631 6.63554 18.9352 7.42671 19.8774 8.42352C20.8196 9.42033 21.1809 10.5688 20.9069 11.6958C20.6328 12.8228 19.7383 13.8673 18.358 14.672L13.998 17.3728",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_18321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 24,
    fill: "white",
    transform: "translate(24 3.95654) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateW);
export default __webpack_public_path__ + "static/media/rotate_w.e59e0f57ff10e3ed98e8985b17f1ddd3.svg";
export { ForwardRef as ReactComponent };